import React__default from 'react';
import clsx from 'clsx';

// Conditionnal Rendering for "a" tag
var KImageWidgetUrl = function (_a) {
    var children = _a.children, image = _a.image, url = _a.url, _b = _a.testId, testId = _b === void 0 ? "KImageWidgetUrl" : _b, className = _a.className, id = _a.id;
    var target = !!(url === null || url === void 0 ? void 0 : url.targetBlank) && url.targetBlank ? "_BLANK" : undefined;
    var title = (url === null || url === void 0 ? void 0 : url.title) || (image === null || image === void 0 ? void 0 : image.alt) || "";
    var classNameKImageWidgetUrl = clsx("KImageWidgetUrl", className);
    if (!(url === null || url === void 0 ? void 0 : url.ComponentNextLink) && (url === null || url === void 0 ? void 0 : url.href)) {
        return (React__default.createElement("a", { id: id, href: url.href, title: title, target: target, "data-testid": testId, rel: "noreferrer", className: classNameKImageWidgetUrl }, children));
    }
    else if (url === null || url === void 0 ? void 0 : url.ComponentNextLink) {
        var ComponentNextLink = url.ComponentNextLink;
        return (React__default.createElement(ComponentNextLink, { href: url.href, target: target, className: classNameKImageWidgetUrl, title: title, testId: testId, rel: "noreferrer", handleClickLink: url.handleClickLink }, children));
    }
    return React__default.createElement(React__default.Fragment, null, children);
};

export { KImageWidgetUrl as default };
//# sourceMappingURL=index.js.map
